import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';

// Its own module, and not just for tidiness: this is a pure classification of
// MSAL errors and must not drag in authConfig.ts, which THROWS at import when
// VITE_ENTRA_CLIENT_ID is unset. Testing it through api.ts meant the suite
// passed locally (where .env.local exists) and failed in CI, which is the
// wrong way round for a deploy gate to behave.

/**
 * MSAL failures that mean "the session is gone, send them to sign in" WITHOUT
 * being an InteractionRequiredAuthError.
 *
 * ⚠ This set exists because of a real bug. When the hidden-iframe silent
 * renewal cannot complete — an expired Entra session, or a browser blocking
 * third-party cookies — MSAL throws a BrowserAuthError, NOT an
 * InteractionRequiredAuthError. The original code only redirected on the
 * latter, so the raw string
 *
 *   monitor_window_timeout: Token acquisition in iframe failed due to timeout
 *
 * was rendered to the user instead of signing them back in. Reproduced on
 * September 14, 2026 simply by returning to an open tab the next day, which is
 * about the most ordinary thing a customer can do.
 */
export const SESSION_GONE_ERRORS = new Set(['monitor_window_timeout', 'empty_window_error']);

export function needsInteractiveSignIn(err: unknown): boolean {
  if (err instanceof InteractionRequiredAuthError) return true;
  return err instanceof BrowserAuthError && SESSION_GONE_ERRORS.has(err.errorCode);
}

